import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { EmptyListComponent } from '../empty-list/empty-list.component';
import { Params } from '@angular/router';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-list-result',
  styleUrls: ['./list-result.component.scss'],
  templateUrl: './list-result.component.html',
  imports: [EmptyListComponent],
})
export class ListResultComponent implements OnChanges {
  @Input() public disableCreationFlag = false;
  @Input() public elementCreationIcon = 'svg_search_guide';
  @Input() public elementCreationLink: string;
  @Output() public elementCreationLinkClickedEvent = new EventEmitter<void>();
  @Input() public elementCreationLinkLabel: string | null;
  @Input() public elementCreationMessage: string;
  @Input() public elementCreationMessage2: string;
  @Input() public elementCreationQueryParams: Params;
  @Input() public existenceFlag: boolean | null | undefined;

  @Input() public prerequisites1CreationIcon = 'sentiment_dissatisfied';
  @Input() public prerequisites1CreationLink: string;
  @Input() public prerequisites1CreationLinkLabel: string | null;
  @Input() public prerequisites1CreationMessage: string;
  @Input() public prerequisites1CreationMessage2: string;
  @Input() public prerequisites1TotalCount: number | boolean | null | undefined;

  @Input() public prerequisites2CreationIcon = 'sentiment_dissatisfied';
  @Input() public prerequisites2CreationLink: string;
  @Input() public prerequisites2CreationLinkLabel: string | null;
  @Input() public prerequisites2CreationMessage: string;
  @Input() public prerequisites2CreationMessage2: string;
  @Input() public prerequisites2TotalCount: number | boolean | null | undefined;

  @Input() public prerequisites3CreationIcon = 'sentiment_dissatisfied';
  @Input() public prerequisites3CreationLink: string;
  @Input() public prerequisites3CreationLinkLabel: string | null;
  @Input() public prerequisites3CreationMessage: string;
  @Input() public prerequisites3CreationMessage2: string;
  @Input() public prerequisites3TotalCount: number | boolean | null | undefined;

  @Input() public totalCount: number | undefined;

  public displayMode: string | null = null;

  /**
   * Determine which view to display inside the page:
   *  nothing : used at the first loading when we don't want to show "no result" screen to the user waiting the API answer.
   *  the list
   *  the 'no result for the selected criteria' icon
   *  the 'no 'element', please create one' icon
   */
  public determineDisplayMode(): string {
    if (this.totalCount && this.totalCount > 0) {
      return 'List';
    } else {
      if (this.disableCreationFlag === true || this.existenceFlag === null || this.existenceFlag === undefined) {
        return 'EmptyList';
      }

      if (this.prerequisites1TotalCount !== null && this.prerequisites1TotalCount !== undefined) {
        if ((this.prerequisites1TotalCount as number) < 1) {
          return 'NoOptions1';
        }
      }

      if (this.prerequisites2TotalCount !== null && this.prerequisites2TotalCount !== undefined) {
        if ((this.prerequisites2TotalCount as number) < 1) {
          return 'NoOptions2';
        }
      }

      if (this.prerequisites3TotalCount !== null && this.prerequisites3TotalCount !== undefined) {
        if ((this.prerequisites3TotalCount as number) < 1) {
          return 'NoOptions3';
        }
      }

      if (!this.existenceFlag) {
        return 'NoElement';
      }

      return 'EmptyList';
    }
  }

  public elementCreationLinkClickedHandler(): void {
    this.elementCreationLinkClickedEvent.emit();
  }

  public ngOnChanges(): void {
    this.displayMode = this.determineDisplayMode();
  }
}
